import React, { useState } from "react";
import { MolecularBg } from "../components/MolecularBg";
import { Mail, MessageSquare, Send } from "lucide-react";
import { toast } from "sonner";
import { useSEO } from "../lib/useSEO";

export const ContactPage = () => {
    useSEO({
        title: "Contact Us — Research Support & Order Enquiries · Carbon Labs AU",
        description: "Get in touch with the Carbon Labs team for research support, manufacturer-supplied COA requests, or order enquiries. Sydney-based, same-day reply on business days.",
    });
    const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
    const [sent, setSent] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        // Visual-only submission (no backend endpoint for contact)
        setSent(true);
        toast.success("Message received. We'll respond within 24 hours.");
        setForm({ name: "", email: "", subject: "", message: "" });
        setTimeout(() => setSent(false), 4000);
    };

    return (
        <div className="pt-28 pb-20 min-h-screen relative" data-testid="contact-page">
            <MolecularBg intensity="low" />
            <div className="container-x relative z-10 max-w-4xl">
                <span className="eyebrow">// Get in touch</span>
                <h1 className="font-display text-4xl md:text-6xl font-extrabold text-white tracking-tighter mt-2 mb-10">Contact Lab</h1>

                <div className="grid md:grid-cols-3 gap-8">
                    <div className="space-y-4">
                        <div className="glass-elevated rounded-2xl p-5">
                            <Mail size={20} className="text-[var(--neon-cyan)] mb-2" />
                            <div className="text-[10px] font-mono uppercase tracking-widest text-[var(--text-muted)]">Email</div>
                            <a href="mailto:carbonlabsau@outlook.com" className="font-display text-white hover:text-[var(--gold)]">carbonlabsau@outlook.com</a>
                        </div>
                        <div className="glass-elevated rounded-2xl p-5">
                            <MessageSquare size={20} className="text-[var(--neon-purple)] mb-2" />
                            <div className="text-[10px] font-mono uppercase tracking-widest text-[var(--text-muted)]">Lab partnerships</div>
                            <a href="mailto:carbonlabsau@outlook.com" className="font-display text-white hover:text-[var(--gold)]">carbonlabsau@outlook.com</a>
                        </div>
                    </div>
                    <form onSubmit={submit} className="md:col-span-2 glass-elevated rounded-2xl p-6 space-y-4" data-testid="contact-form">
                        <div className="grid md:grid-cols-2 gap-3">
                            <input
                                required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                                placeholder="Your name" className="px-4 py-2.5 bg-black/40 border border-white/10 rounded-full text-sm text-white placeholder:text-[var(--text-muted)] focus:outline-none focus:border-[var(--neon-cyan)]"
                                data-testid="contact-name" />
                            <input
                                required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                                placeholder="Email" className="px-4 py-2.5 bg-black/40 border border-white/10 rounded-full text-sm text-white placeholder:text-[var(--text-muted)] focus:outline-none focus:border-[var(--neon-cyan)]"
                                data-testid="contact-email" />
                        </div>
                        <input
                            required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}
                            placeholder="Subject" className="w-full px-4 py-2.5 bg-black/40 border border-white/10 rounded-full text-sm text-white placeholder:text-[var(--text-muted)] focus:outline-none focus:border-[var(--neon-cyan)]"
                            data-testid="contact-subject" />
                        <textarea
                            required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
                            placeholder="Your message..." className="w-full px-4 py-3 bg-black/40 border border-white/10 rounded-2xl text-sm text-white placeholder:text-[var(--text-muted)] focus:outline-none focus:border-[var(--neon-cyan)] resize-none"
                            data-testid="contact-message" />
                        <button type="submit" className="btn-solid" data-testid="contact-submit">
                            {sent ? "Sent ✓" : <>Send Message <Send size={14} /></>}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};
